import { render, staticRenderFns } from "./hekang.vue?vue&type=template&id=f7527660&scoped=true&"
import script from "./hekang.vue?vue&type=script&lang=js&"
export * from "./hekang.vue?vue&type=script&lang=js&"
import style0 from "./hekang.vue?vue&type=style&index=0&id=f7527660&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7527660",
  null
  
)

export default component.exports